import { lazy, Suspense, useEffect } from 'react';
import { StepperContainer, StepperProvider } from '../StepperContainer';
import { useStepperContext } from '../../../../components/Stepper/Context';
import { TRANSFER_STEP_SESSION_KEY } from './constants';

const CompanyTransferDataPage = lazy(() => import('./CompanyTransferData'));
const CompanyTransferDirectorsPage = lazy(() => import('./DirectorsPage'));
const CompanyTransferShareholdersPage = lazy(() => import('./ShareholdersPage'));
const CompanyTransferSummaryPage = lazy(() => import('./SummaryPage'));

const STEPS = [
  { id: 'transfer-data-step', order: 1 },
  { id: 'transfer-directors-step', order: 2 },
  { id: 'transfer-shareholders-step', order: 3 },
  { id: 'transfer-summary-step', order: 4 }
];

const STEP_IDS = STEPS.map((step) => step.id);

const getInitialStep = () => {
  const storedStep = sessionStorage.getItem(TRANSFER_STEP_SESSION_KEY);
  return storedStep && STEP_IDS.includes(storedStep) ? storedStep : 'transfer-data-step';
};

// Criar/trocar a empresa (registerCompanyTransfer -> changeCompanySelected) troca o token no
// meio do wizard. Trocar o token dispara AuthGuard.isLoading, que desmonta e remonta toda a
// rota enquanto refaz o /me — o que apaga o estado local do StepperProvider. Persistimos o
// step atual na sessionStorage para sobreviver a esse remonte e não voltar pro passo 1.
const StepPersistence = () => {
  const stepperContext = useStepperContext();

  useEffect(() => {
    if (stepperContext.currentStep) {
      sessionStorage.setItem(TRANSFER_STEP_SESSION_KEY, stepperContext.currentStep.id);
    }
  }, [stepperContext.currentStep]);

  return null;
};

export const CompanyTransferOffshore = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <StepperProvider steps={STEPS} initialStep={getInitialStep()}>
      <StepPersistence />
      <StepperContainer step="transfer-data-step" component={CompanyTransferDataPage} />
      <StepperContainer step="transfer-directors-step" component={CompanyTransferDirectorsPage} />
      <StepperContainer step="transfer-shareholders-step" component={CompanyTransferShareholdersPage} />
      <StepperContainer step="transfer-summary-step" component={CompanyTransferSummaryPage} />
    </StepperProvider>
  </Suspense>
);
